import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeEnUs from '@angular/common/locales/en';
import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, Inject, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { GlobalErrorHandler } from '@assetaccountant/core';
import { CoreModule } from '@assetaccountant/core/core.module';
import { HttpAuthInterceptor } from '@assetaccountant/core/http-auth.interceptor';
import { HttpLoadingInterceptor } from '@assetaccountant/core/http-loading.interceptor';
import { HttpServiceWorkerBypassInteceptor } from '@assetaccountant/core/http-service-worker-bypass.interceptor';
import { HttpTokenInterceptor } from '@assetaccountant/core/http-token.interceptor';
import { AADateParserFormatter } from '@assetaccountant/core/utils/aadate-parser-formatter';
import { TODAY, toUniversalDateString } from '@assetaccountant/core/utils/date-utils';
import { NgbDateParserFormatter, NgbModalConfig, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'environments/environment';
import '@leasequery/finquery-navigation';
import moment from 'moment';
import { MomentModule } from 'ngx-moment';
import { ToastrModule } from 'ngx-toastr';
import { LogoutComponent } from './@public/components/logout.component';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';
import { AppSettings } from './app.settings';
import { decorateLocale } from './locale.decorate';

registerLocaleData(decorateLocale(localeEnUs as any));

moment.relativeTimeThreshold('ss', 9);

@NgModule({
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    CoreModule,
    FormsModule,
    MomentModule.forRoot({
      relativeTimeThresholdOptions: {
        ss: 9,
      },
    }),
    NgbModule,
    ReactiveFormsModule,
    ServiceWorkerModule.register('ngsw-worker.js'),
    ToastrModule.forRoot({
      timeOut: 10000,
      // eslint-disable-next-line ize/ize
      positionClass: 'toast-top-center',
      preventDuplicates: true,
      closeButton: true,
      maxOpened: 3,
    }),
  ],
  declarations: [AppComponent, LogoutComponent],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpAuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpLoadingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpServiceWorkerBypassInteceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpTokenInterceptor,
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useValue: AppSettings.locale,
    },
    {
      provide: NgbDateParserFormatter,
      useClass: AADateParserFormatter,
    },
    {
      provide: NgbModalConfig,
      useValue: {
        animation: true,
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
      } as Partial<NgbModalConfig>,
    },
    {
      provide: TODAY,
      useFactory: () => toUniversalDateString(moment.utc(), { throwOnFailure: true }),
    },
    ...environment.providers,
  ],
  exports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(@Inject(ErrorHandler) errorHandler: GlobalErrorHandler) {
    errorHandler.init();
  }
}
